import { BaseRouteService } from "core/services";

class HistoryRouteService extends BaseRouteService {
	constructor() {
		super("history");	
	}	
	
	findFacilityOrderHistory(filter) {
		return super.find(`${this.base}/facility-order{?facilityOrderId,patientId,facilityOrderTemplateId,searchQuery,page,rpp,sort,embed,fields}`, filter);
	}

	findNikoOrderHistory(filter) {
		return super.find(`${this.base}/niko-order{?recordId,searchQuery,page,rpp,sort,embed,fields,patientId,patientTemplateId}`, filter);
	}

	getRecordHistory(params){
		return super.find(`${this.base}/record{?recordId,fieldName,value}`, params);
	}

	getItemActionHistory(itemId){
		return `${this.base}/item-action/${itemId}`;
	}
	
	getInsuranceChangeHistory(nikoPatientDetailId){
		return `${this.base}/insurance-changes/${nikoPatientDetailId}`;
	}
}

export default HistoryRouteService;
